import Vue from 'vue';

Vue.component('wasted-ingredient-index', () =>
    import(/* webpackChunkName: 'index' */ './wasted-ingredient-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/wasted-ingredient/index.js